import React, { useContext } from 'react';
import {Navigate, Outlet } from 'react-router-dom';
import { Context }  from './../Auth.Context';

const PublicOnlyRoute = () => {
    const [adminDetails] = useContext(Context);

	if(!adminDetails || !adminDetails._id){
		return <Outlet />
	}
	// else if (adminDetails && adminDetails._id) return <Navigate to="/customer" />;
	else return null;
};
export default PublicOnlyRoute;